import { SvgIconComponent } from '@mui/icons-material';
import { useAppSelector } from '../../../app/hooks';

import { BaseRequiredDialogProps } from '@bloomfieldrobotics/canopy';
import {
  ChartDropdownDimensionEnum,
  CubeMeasureEnum,
  FeatureEnum,
} from '../../../services/data/impl/cube/cubeSlice';
import { isBlueberryFeature } from '../../../services/data/impl/cube/cubeUtils';
import { selectCurrFeature, selectCurrMeasure } from '../../select/selectSlice';
import {
  BlueberryPerRowsideAction,
  useBlueberryPerRowsideActions,
} from '../blueberry/perRowside/hooks/useBlueberryPerRowsideActions';
import {
  BlueberrySizeChartAction,
  useBlueberrySizeChartActions,
} from '../blueberry/sizing/hooks/useBlueberrySizeChartActions';
import {
  GrapeDiameterDistributionChartAction,
  useGrapeDiameterDistributionChartActions,
} from './useGrapeDiameterDistributionChartActions';

export type ChartAction<T = string> = {
  actionId: T;
  onClick: () => void;
  Icon: SvgIconComponent;
  ActionDialog?: React.JSXElementConstructor<BaseRequiredDialogProps>;
};

export const useChartActions = (): ChartAction<AllPossibleActions>[] => {
  const currFeature = useAppSelector(selectCurrFeature);
  const currMeasure = useAppSelector(selectCurrMeasure);
  const currChartDimension = useAppSelector(
    (state) => state.cube.currChartDimension
  );
  const actions: ChartAction<AllPossibleActions>[] = [];

  /** Blueberry Chart Actions */
  const blueberryPerRowsideActions = useBlueberryPerRowsideActions();
  const blueberrySizeActions = useBlueberrySizeChartActions();
  const grapeDiameterDistributionActions =
    useGrapeDiameterDistributionChartActions();

  if (isBlueberryFeature(currFeature)) {
    if (currChartDimension === ChartDropdownDimensionEnum.perRowside) {
      actions.push(...blueberryPerRowsideActions);
    } else if (currChartDimension === ChartDropdownDimensionEnum.fruitSize) {
      actions.push(...blueberrySizeActions);
    }
  } else if (
    currFeature === FeatureEnum.berries &&
    currMeasure === CubeMeasureEnum.DetectionFactAvgLength &&
    currChartDimension === ChartDropdownDimensionEnum.distribution
  ) {
    actions.push(...grapeDiameterDistributionActions);
  }
  return actions;
};

export type AllPossibleActions =
  | BlueberryPerRowsideAction
  | BlueberrySizeChartAction
  | GrapeDiameterDistributionChartAction;
